import type { LocalAuditSession } from '../../local/types';

/** Notes/tasks/files on this device still waiting to upload. */
export function pendingAdditive(session: LocalAuditSession): number {
  return (
    (session.notes ?? []).filter((n) => n.serverId === undefined && !n.rejected).length +
    (session.taskDrafts ?? []).filter((t) => t.serverId === undefined && !t.rejected).length +
    (session.attachments ?? []).filter(
      (a) => a.serverItemId === undefined && !a.missingBlob,
    ).length
  );
}

/**
 * Plain-language status for an audit this device can no longer work on
 * (cancelled here, expired, or closed by another device). Empty for open
 * or submitted audits.
 */
export function closedAuditMessage(session: LocalAuditSession): string {
  switch (session.status) {
    case 'cancelled':
      return 'This audit was cancelled.';
    case 'expired':
      return 'This audit expired — audits must be submitted within 72 hours of being started.';
    case 'closed_elsewhere': {
      const why = session.closedElsewhere?.reason;
      const base =
        why === 'continued'
          ? 'This audit was continued on another device.'
          : why === 'submitted'
            ? 'This audit was submitted from another device.'
            : why === 'cancelled'
              ? 'This audit was cancelled from another device.'
              : why === 'expired'
                ? 'This audit expired.'
                : 'This audit no longer exists.';
      const lost = session.closedElsewhere?.discardedAnswers ?? 0;
      return lost > 0
        ? `${base} ${lost} answer${lost > 1 ? 's' : ''} changed on this device had not synced yet and ${lost > 1 ? 'were' : 'was'} not applied.`
        : base;
    }
    default:
      return '';
  }
}
